import gql from 'graphql-tag';
import React from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';
import {
  getOfficeBrandLogo,
  getOfficeBrandName,
  getOfficeBrandSecondaryName,
} from '../../shared/utils/officeBranding';
import { buildPracticeSchedulingUrl } from '../../shared/utils/urls';
import WidgetHeader from './WidgetHeader';

interface WidgetOfficeHeaderProps {
  office: {
    id: string;
    display: string;
    messagingName: string | null;
    practice: {
      id: string;
      display: string;
      logo: string;
      logo2x: string;
    };
    group: {
      id: string;
      name: string;
      logo: string;
      logo2x: string;
    } | null;
  };
}

export default function WidgetOfficeHeader({ office }: WidgetOfficeHeaderProps) {
  const intl = useIntl();
  const location = useLocation();
  const title = getOfficeBrandName(office);
  const subtitle = getOfficeBrandSecondaryName(office);
  const { logo, logo2x } = getOfficeBrandLogo(office);
  if (office.group) {
    return (
      // There isn't a Group scheduling page yet, so we're not going to set a change URL
      <WidgetHeader
        title={title}
        subtitle={subtitle}
        photo={logo}
        photo2x={logo2x}
        showBackButton
      />
    );
  }
  return (
    <WidgetHeader
      title={title}
      subtitle={subtitle}
      photo={logo}
      photo2x={logo2x}
      changeUrl={buildPracticeSchedulingUrl(office.practice.id, { location })}
      changeText={intl.formatMessage({
        id: 'widgets.WidgetOfficeHeader.changeText',
        defaultMessage: 'Change Office',
      })}
      showBackButton
    />
  );
}

export const WidgetOfficeHeaderFragment = {
  name: 'WidgetOfficeHeader',
  query: gql`
    fragment WidgetOfficeHeader on Office {
      id
      display
      messagingName
      group {
        id
        name
        logo(size: 60)
        logo2x: logo(size: 120)
      }
      practice {
        id
        display
        logo: logo(size: 35)
        logo2x: logo(size: 70)
      }
    }
  `,
};
